function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FETCH_PRINT_NOTES_SUCCESS, FETCH_NOTES_SUCCESS, FETCH_SINGLE_NOTE_SUCCESS, FETCH_SINGLE_TOPIC_SUCCESS, UPDATE_TOPIC_SUCCESS } from "../actions";
import initialState from "./initialState";
import { forEach, assign } from "lodash";
export default function notes() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.notes, action = arguments.length > 1 ? arguments[1] : void 0;
    var newNotes;
    switch(action.type){
        case FETCH_NOTES_SUCCESS:
            {
                newNotes = forEach(state.notes, function(n) {
                    n.__hidden = true;
                });
                forEach(action.notes, function(rawNote) {
                    var noteId = rawNote.id;
                    newNotes[noteId] = assign(newNotes[noteId] ? _objectSpreadProps(_objectSpread({}, newNotes[noteId]), {
                        __hidden: false
                    }) : {
                        __hidden: false
                    }, rawNote);
                });
                return _objectSpreadProps(_objectSpread({}, state), {
                    notes: newNotes
                });
            }
        case FETCH_PRINT_NOTES_SUCCESS:
            return _objectSpreadProps(_objectSpread({}, state), {
                printNotes: action.printNotes
            });
        case FETCH_SINGLE_NOTE_SUCCESS:
            {
                newNotes = _objectSpread({}, state.notes);
                var noteId = action.note.id;
                newNotes[noteId] = assign(newNotes[noteId] ? _objectSpreadProps(_objectSpread({}, newNotes[noteId]), {
                    __hidden: false
                }) : {
                    __hidden: false
                }, action.note);
                return _objectSpreadProps(_objectSpread({}, state), {
                    notes: newNotes
                });
            }
        // Since Notes and Topics share the same editor and both run over updateTopic this is necessary
        case FETCH_SINGLE_TOPIC_SUCCESS:
            {
                newNotes = _objectSpread({}, state.notes);
                var topicId = action.topic.id;
                if (state.notes[topicId]) {
                    newNotes[topicId] = assign(newNotes[topicId] ? _objectSpreadProps(_objectSpread({}, newNotes[topicId]), {
                        __hidden: false
                    }) : {
                        __hidden: false
                    }, action.topic);
                }
                return _objectSpreadProps(_objectSpread({}, state), {
                    notes: newNotes
                });
            }
        case UPDATE_TOPIC_SUCCESS:
            {
                console.log(action);
                newNotes = _objectSpread({}, state.notes);
                var topicId1 = action.topicId;
                if (state.notes[topicId1] && topicId1) {
                    newNotes[topicId1] = assign(newNotes[topicId1] ? _objectSpreadProps(_objectSpread({}, newNotes[topicId1]), {
                        __hidden: false,
                        description: action.activity,
                        title: action.topic.title
                    }) : {
                        __hidden: false
                    });
                }
                return _objectSpreadProps(_objectSpread({}, state), {
                    notes: newNotes
                });
            }
        default:
            return state;
    }
}
